<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

/* Reset global styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-tap-highlight-color: transparent;
  overscroll-behavior-y: none;
}

/* Prevent horizontal overflow caused by off-screen fixed elements (mobile drawer, etc.).
   `clip` is preferred over `hidden` here: `overflow-x: hidden` on <html> creates a new
   scroll context on iOS Safari and can break vertical touch scrolling. `clip` only clips. */
html, body {
  overflow-x: hidden; /* fallback for browsers without `clip` (iOS Safari < 16) */
  overflow-x: clip;
}

@media (max-width: 640px) {
  body {
    -webkit-text-size-adjust: 100%;
  }
}

/* Sidebar becomes drawer under 1024px → reclaim the 240px gutter for main content */
@media (max-width: 1024px) {
  .main {
    margin-left: 0 !important;
  }
}
</style>